import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import DepartmentSelectMain from '../../../../form/fields/DepartmentSelectMain'
import { setWriteOffActsFiltersDepartmentId } from '../../../../../store/writeOffSlice'

const WriteOffActsFilterDepartment = () => {

    const departmentId = useSelector(state => state.writeOff.writeOffActs.filters.departmentId)
    const dispatch = useDispatch()

    const [value, setValue] = useState(departmentId ? departmentId : '')

  return (
    <DepartmentSelectMain
        // departmentTypeId={value}
        required={false}
        setValidate={e => {}}
        setValueForm={e => {
            dispatch(setWriteOffActsFiltersDepartmentId(e))
            setValue(e)
        }}
        forciblyValue={value}
        optionDefault={{
            value: '',
            name: 'Всі'
        }}
        withoutType={true}
    />
  )
}

export default WriteOffActsFilterDepartment